import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

/* ─────────────────────── FONTS + GLOBAL CSS ─────────────────────── */
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,750;12..96,800&family=DM+Sans:wght@300;400;500;600&display=swap');

    @keyframes solScan {
      0%   { top: 0;    opacity: 1;  }
      70%  { opacity: .7; }
      100% { top: 100%; opacity: 0;  }
    }
    @keyframes solBeam {
      0%   { opacity: 0; transform: translateX(-100%); }
      50%  { opacity: 1; }
      100% { opacity: 0; transform: translateX(100%); }
    }

    .sol-card  { position: relative; overflow: hidden; }
    .sol-scan  {
      position: absolute; left: 0; right: 0; top: 0;
      height: 2px;
      background: linear-gradient(90deg, transparent, rgba(30,144,255,.72), transparent);
      opacity: 0; pointer-events: none; z-index: 10;
    }
    .sol-card:hover .sol-scan {
      opacity: 1;
      animation: solScan .68s ease-in-out forwards;
    }
    .sol-beam {
      position: absolute; bottom: 0; left: 0; right: 0;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(30,144,255,.35), transparent);
      animation: solBeam 4s ease-in-out infinite;
      pointer-events: none;
    }
    .sol-grain {
      position: absolute; inset: 0;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
      opacity: .025; mix-blend-mode: overlay; pointer-events: none; z-index: 0;
    }
  `}</style>
);

/* ─────────────────────── SVG ICONS ─────────────────────────────── */
const KnowledgeIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" width="100%" height="100%">
    <circle cx="10" cy="10" r="2.6" stroke="currentColor" strokeWidth="1.3"/>
    <line x1="10" y1="7.4" x2="10" y2="2.2"   stroke="currentColor" strokeWidth="1.1"/>
    <line x1="12.2" y1="8.2" x2="16.4" y2="5" stroke="currentColor" strokeWidth="1.1"/>
    <line x1="12.2" y1="11.8" x2="16.4" y2="15" stroke="currentColor" strokeWidth="1.1"/>
    <line x1="10" y1="12.6" x2="10" y2="17.8"  stroke="currentColor" strokeWidth="1.1"/>
    <line x1="7.8" y1="11.8" x2="3.6" y2="15"  stroke="currentColor" strokeWidth="1.1"/>
    <line x1="7.8" y1="8.2"  x2="3.6" y2="5"   stroke="currentColor" strokeWidth="1.1"/>
    <circle cx="10"  cy="1.6"  r="1.4" fill="currentColor"/>
    <circle cx="17"  cy="4.4"  r="1.2" fill="currentColor"/>
    <circle cx="17"  cy="15.6" r="1.2" fill="currentColor"/>
    <circle cx="10"  cy="18.4" r="1.4" fill="currentColor"/>
    <circle cx="3"   cy="15.6" r="1.2" fill="currentColor"/>
    <circle cx="3"   cy="4.4"  r="1.2" fill="currentColor"/>
  </svg>
);
const HealthIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" width="100%" height="100%">
    <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.3"/>
    <path d="M10 5.5V14.5M5.5 10H14.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
  </svg>
);
const VoiceIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" width="100%" height="100%">
    <rect x="7" y="2" width="6" height="9" rx="3" stroke="currentColor" strokeWidth="1.3"/>
    <path d="M4 10C4 13.3 6.7 16 10 16C13.3 16 16 13.3 16 10" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M10 16V19M7.5 19H12.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);
const MessIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" width="100%" height="100%">
    <path d="M6 2V8C6 10 8 11 8 11V18" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 2V6M6 6H4M8 2V6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M13 2C13 2 15.5 4.5 15.5 8C15.5 10.5 13.5 11.5 13.5 11.5V18" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const BusIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" width="100%" height="100%">
    <rect x="2" y="5" width="13" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.3"/>
    <circle cx="5.5"  cy="15.5" r="1.5" stroke="currentColor" strokeWidth="1.2"/>
    <circle cx="11.5" cy="15.5" r="1.5" stroke="currentColor" strokeWidth="1.2"/>
    <path d="M2 9.5H15" stroke="currentColor" strokeWidth="1.2"/>
    <rect x="4"  y="6.5" width="3" height="2" rx=".5" stroke="currentColor" strokeWidth="1"/>
    <rect x="10" y="6.5" width="3" height="2" rx=".5" stroke="currentColor" strokeWidth="1"/>
    <path d="M15 8.5L18 7.5V12L15 11" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const FeeIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" width="100%" height="100%">
    <path d="M10 2C10 2 5.5 4.5 5.5 9.5V13H14.5V9.5C14.5 4.5 10 2 10 2Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
    <path d="M7.5 13C7.5 14.4 8.6 15.5 10 15.5C11.4 15.5 12.5 14.4 12.5 13" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M3 13H17" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M13 5L14.5 6.5L17 3.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const FeedbackIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" width="100%" height="100%">
    <path d="M2 3.5H13C13.8 3.5 14.5 4.2 14.5 5V11C14.5 11.8 13.8 12.5 13 12.5H7.5L4 16V12.5H2C1.2 12.5 .5 11.8 .5 11V5C.5 4.2 1.2 3.5 2 3.5Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
    <path d="M17 6.5H18.5C19.1 6.5 19.5 6.9 19.5 7.5V12.5C19.5 13.1 19.1 13.5 18.5 13.5H17V15.5L14.5 13.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 7.5H11M4 9.8H8.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

const ICONS = {
  knowledge: <KnowledgeIcon />,
  health:    <HealthIcon />,
  voice:     <VoiceIcon />,
  mess:      <MessIcon />,
  bus:       <BusIcon />,
  fee:       <FeeIcon />,
  feedback:  <FeedbackIcon />,
};

/* ─────────────────────── SOLUTIONS DATA ─────────────────────────── */
const SOLUTIONS = [
  {
    id: "knowledge", gridArea: "featured", featured: true,
    tag: "RAG · Enterprise Search", name: "Real-Time Knowledge Systems",
    desc: "Intelligent retrieval pipelines delivering accurate, context-aware answers from your enterprise knowledge base in milliseconds — at any scale.",
    icon: "knowledge",
    metrics: [
      { val: "<180ms", label: "Avg. Latency" },
      { val: "99.9%",  label: "Uptime SLA"  },
      { val: "50M+",   label: "Queries / mo" },
    ],
  },
  { id: "health",   gridArea: "health",   tag: "Clinical Intelligence", name: "Healthcare AI Systems",              desc: "HIPAA-compliant diagnostics, patient risk scoring, and clinical workflow automation for modern healthcare providers.",                                            icon: "health"   },
  { id: "voice",    gridArea: "voice",    tag: "Conversational AI",     name: "Multilingual Voice-Based Agents",    desc: "Natural-language voice AI handling thousands of concurrent support interactions with human-level understanding.",                                            icon: "voice"    },
  { id: "mess",     gridArea: "mess",     tag: "Ops Automation",        name: "AI Powered Management System",       desc: "AI-powered demand forecasting, waste reduction, and automated systems.",                                                                                   icon: "mess"     },
  { id: "bus",      gridArea: "bus",      tag: "Safety AI",             name: "Safety Monitoring System",           desc: "Real-time GPS with AI safety monitoring, predictive routing, and instant notifications.",                                                                  icon: "bus"      },
  { id: "fee",      gridArea: "fee",      tag: "FinOps AI",             name: "Reminder Automation System",         desc: "Intelligent multi-channel recovery through personalised nudges.",                                                                                         icon: "fee"      },
  { id: "feedback", gridArea: "feedback", tag: "Analytics AI",          name: "Customer Feedback Intelligence System", desc: "Sentiment analysis, trend detection, and automated escalation turning raw feedback into strategic insight.",                                           icon: "feedback" },
];

/* ─────────────────────── KNOWLEDGE GRAPH VIZ ───────────────────── */
const KnowledgeViz = () => {
  const NODES = [
    { cx: 150, cy: 22,  r: 6,  label: "API", lx: 156, ly: 19  },
    { cx: 248, cy: 58,  r: 5,  label: "LLM", lx: 254, ly: 55  },
    { cx: 275, cy: 138, r: 7,  label: "RAG", lx: 284, ly: 135 },
    { cx: 228, cy: 214, r: 5,  label: "DB",  lx: 234, ly: 211 },
    { cx: 72,  cy: 214, r: 6,  label: "VEC", lx: 50,  ly: 222 },
    { cx: 25,  cy: 138, r: 5,  label: "CTX", lx: 3,   ly: 135 },
    { cx: 62,  cy: 48,  r: 6,  label: "NLP", lx: 40,  ly: 46  },
  ];
  const EDGES = [
    [150,125,150,22 ],[150,125,248,58 ],[150,125,275,138],
    [150,125,228,214],[150,125,72,214 ],[150,125,25,138 ],
    [150,125,62,48  ],[150,22,248,58  ],[248,58,275,138 ],
    [72,214,228,214 ],[25,138,62,48   ],
  ];

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, scale: .88 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.1, ease: [.22,1,.36,1], delay: .3 }}
      sx={{
        width: "100%",
        // Scale viz naturally within its container; never overflow
        maxWidth: { xs: 220, sm: 260, md: 300, lg: 320, xl: 360 },
        mx: "auto",
      }}
    >
      <svg viewBox="0 0 300 250" fill="none"
           style={{ width: "100%", height: "auto", overflow: "visible", display: "block" }}>
        <defs>
          <radialGradient id="kVizGlow" cx="50%" cy="50%" r="50%">
            <stop offset="0%"   stopColor="rgba(30,144,255,.28)"/>
            <stop offset="100%" stopColor="rgba(30,144,255,0)"/>
          </radialGradient>
        </defs>
        <ellipse cx="150" cy="125" rx="105" ry="92" fill="url(#kVizGlow)"/>
        {EDGES.map(([x1,y1,x2,y2], i) => (
          <motion.line key={i} x1={x1} y1={y1} x2={x2} y2={y2}
            stroke="rgba(30,144,255,.18)" strokeWidth={i < 7 ? ".9" : ".5"}
            strokeDasharray="4 7"
            animate={{ strokeDashoffset: [28, 0] }}
            transition={{ duration: 3 + (i % 4) * .6, repeat: Infinity, ease: "linear" }}
          />
        ))}
        <motion.circle cx="150" cy="125" r="46" fill="none"
          stroke="rgba(30,144,255,.1)" strokeWidth=".7" strokeDasharray="2 9"
          animate={{ strokeDashoffset: [44, 0] }}
          transition={{ duration: 9, repeat: Infinity, ease: "linear" }}
        />
        <motion.circle cx="150" cy="125" r="78" fill="none"
          stroke="rgba(30,144,255,.055)" strokeWidth=".5" strokeDasharray="1.5 11"
          animate={{ strokeDashoffset: [0, 52] }}
          transition={{ duration: 14, repeat: Infinity, ease: "linear" }}
        />
        {NODES.map((n, i) => (
          <g key={i}>
            <motion.circle cx={n.cx} cy={n.cy} r={n.r + 5} fill="rgba(30,144,255,.065)"
              animate={{ r:[n.r+4, n.r+9, n.r+4], opacity:[.5,.85,.5] }}
              transition={{ duration: 2.6, delay: i*.22, repeat: Infinity, ease: "easeInOut" }}
            />
            <circle cx={n.cx} cy={n.cy} r={n.r}
              fill="rgba(30,144,255,.45)" stroke="rgba(30,144,255,.28)" strokeWidth=".8"
              style={{ filter: "drop-shadow(0 0 4px rgba(30,144,255,.5))" }}
            />
            <text x={n.lx} y={n.ly} fontSize="6.5"
              fill="rgba(30,144,255,.45)" fontFamily="DM Sans, sans-serif">
              {n.label}
            </text>
          </g>
        ))}
        <motion.circle cx="150" cy="125"
          animate={{ r:[22,30,22], opacity:[.4,.7,.4] }}
          transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
          fill="rgba(30,144,255,.1)" r="22"
        />
        <motion.circle cx="150" cy="125"
          animate={{ r:[13,17,13], opacity:[.6,.9,.6] }}
          transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut", delay: .6 }}
          fill="rgba(30,144,255,.2)" r="13"
        />
        <circle cx="150" cy="125" r="7.5" fill="#1E90FF"
          style={{ filter: "drop-shadow(0 0 12px #1E90FF) drop-shadow(0 0 20px rgba(30,144,255,.35))" }}
        />
      </svg>
    </Box>
  );
};

/* ─────────────────────── TAG PILL ───────────────────────────────── */
const TagPill = ({ label, size = "sm" }) => (
  <Box sx={{
    display: "inline-flex",
    alignItems: "center",
    gap: size === "lg" ? 1 : .75,
    px: size === "lg" ? "12px" : "10px",
    py: size === "lg" ? "6px"  : "5px",
    borderRadius: "999px",
    background: "rgba(30,144,255,.07)",
    border: "1px solid rgba(30,144,255,.2)",
    width: "fit-content",
    // Never let the pill overflow its card
    maxWidth: "100%",
    overflow: "hidden",
  }}>
    <Box sx={{
      width: size === "lg" ? 6 : 5,
      height: size === "lg" ? 6 : 5,
      borderRadius: "50%",
      background: "#1E90FF",
      boxShadow: "0 0 8px #1E90FF",
      flexShrink: 0,
    }}/>
    <Typography sx={{
      fontFamily: "'DM Sans', sans-serif",
      fontSize: size === "lg" ? "clamp(.62rem,1vw,.7rem)" : "clamp(.58rem,.9vw,.64rem)",
      fontWeight: 600,
      color: "rgba(30,144,255,.78)",
      letterSpacing: ".09em",
      textTransform: "uppercase",
      // Truncate if truly no space
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}>
      {label}
    </Typography>
  </Box>
);

/* ─────────────────────── FEATURED CARD ──────────────────────────── */
const FeaturedCard = ({ sol }) => (
  <Box
    component={motion.div}
    initial={{ opacity: 0, y: 30, filter: "blur(6px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: .75, ease: [.22,1,.36,1] }}
    whileHover={{ scale: 1.012, transition: { duration: .2 } }}
    className="sol-card"
    sx={{
      height: "100%",
      // minHeight scales: auto on mobile so content decides, fixed on desktop
      minHeight: { xs: "auto", sm: "auto", md: "auto", lg: 440, xl: 480 },
      borderRadius: { xs: "16px", md: "18px" },
      background: "linear-gradient(135deg, rgba(30,144,255,.065) 0%, rgba(30,144,255,.03) 45%, rgba(0,0,0,.22) 100%)",
      border: "1px solid rgba(30,144,255,.2)",
      backdropFilter: "blur(18px)",
      display: "flex",
      // Column on xs/sm; row from md up so both panels have room
      flexDirection: { xs: "column", md: "row" },
      overflow: "hidden",
      position: "relative",
      transition: "border-color .25s ease, box-shadow .25s ease",
      "&:hover": {
        borderColor: "rgba(30,144,255,.35)",
        boxShadow: "0 8px 60px rgba(30,144,255,.09), inset 0 1px 0 rgba(30,144,255,.14)",
      },
      "&::before": {
        content: '""', position: "absolute",
        top: 0, left: "8%", right: "8%", height: "1px",
        background: "linear-gradient(90deg, transparent, rgba(30,144,255,.55), transparent)",
      },
    }}
  >
    <Box className="sol-scan"/>
    <Box className="sol-grain"/>

    {/* ── LEFT — content ── */}
    <Box sx={{
      // On mobile take full width; on md+ take 52%
      flex: { xs: "none", md: "0 0 52%" },
      width: { xs: "100%", md: "52%" },
      p: {
        xs: "24px 20px 20px",
        sm: "28px 24px 24px",
        md: "32px 28px 28px",
        lg: "38px 34px 34px",
        xl: "44px 40px 40px",
      },
      display: "flex",
      flexDirection: "column",
      gap: { xs: "16px", md: "20px", lg: "22px" },
      position: "relative",
      zIndex: 1,
    }}>
      <TagPill label={sol.tag} size="lg"/>

      <Box>
        <Typography sx={{
          fontFamily: "'Bricolage Grotesque', sans-serif",
          fontWeight: 760,
          // Smooth clamp: 1.35rem on 320px → 2.2rem on wide desktop
          fontSize: "clamp(1.35rem, 2.8vw, 2.2rem)",
          lineHeight: 1.12,
          letterSpacing: "-1.2px",
          color: "rgba(255,255,255,.93)",
          mb: { xs: "12px", md: "14px" },
          // Prevent overflow at any width
          wordBreak: "break-word",
          overflowWrap: "break-word",
        }}>
          {sol.name}
        </Typography>
        <Typography sx={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "clamp(.84rem, 1.2vw, .95rem)",
          lineHeight: 1.82,
          color: "rgba(255,255,255,.46)",
          fontWeight: 400,
          maxWidth: { xs: "100%", md: 360, lg: 400 },
        }}>
          {sol.desc}
        </Typography>
      </Box>

      {/* metrics */}
      <Box sx={{
        display: "flex",
        gap: { xs: "20px", sm: "24px", md: "28px", lg: "32px" },
        mt: "auto",
        pt: { xs: "16px", md: "20px" },
        borderTop: "1px solid rgba(255,255,255,.06)",
        // Wrap on very narrow screens so numbers don't squish
        flexWrap: "wrap",
        rowGap: "10px",
      }}>
        {sol.metrics.map((m) => (
          <Box key={m.label} sx={{ display: "flex", flexDirection: "column", gap: .3 }}>
            <Typography sx={{
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontWeight: 720,
              fontSize: "clamp(1.15rem, 2.2vw, 1.6rem)",
              lineHeight: 1,
              color: "rgba(255,255,255,.9)",
              letterSpacing: "-1px",
            }}>
              {m.val}
            </Typography>
            <Typography sx={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "clamp(.6rem,.85vw,.7rem)",
              fontWeight: 500,
              color: "rgba(255,255,255,.3)",
              letterSpacing: ".06em",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}>
              {m.label}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* CTA text link */}
      <Box
        component={motion.div}
        whileHover={{ x: 3 }}
        transition={{ duration: .18 }}
        sx={{ display: "inline-flex", alignItems: "center", gap: .8, cursor: "pointer", width: "fit-content" }}
      >
        <Typography sx={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: "clamp(.76rem, 1vw, .84rem)",
          fontWeight: 600,
          color: "rgba(30,144,255,.7)",
          letterSpacing: ".04em",
        }}>
          Explore solution
        </Typography>
        <Box sx={{ fontSize: "clamp(.76rem, 1vw, .84rem)", color: "rgba(30,144,255,.7)", lineHeight: 1 }}>→</Box>
      </Box>
    </Box>

    {/* ── RIGHT — visualization ── */}
    <Box sx={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // On mobile: compact bottom padding; on md+: proper right padding
      p: {
        xs: "4px 20px 24px",
        sm: "8px 24px 28px",
        md: "24px 24px 24px 0",
        lg: "28px 28px 28px 0",
        xl: "32px 36px 32px 0",
      },
      position: "relative",
      // Prevent viz from making the card taller than needed on mobile
      minHeight: { xs: "auto", md: 0 },
    }}>
      {/* soft vignette on left edge — desktop only */}
      <Box sx={{
        display: { xs: "none", md: "block" },
        position: "absolute", left: 0, top: 0, bottom: 0, width: 60,
        background: "linear-gradient(to right, rgba(2,4,3,.6), transparent)",
        zIndex: 2, pointerEvents: "none",
      }}/>
      <KnowledgeViz />
    </Box>
  </Box>
);

/* ─────────────────────── SOLUTION CARD ──────────────────────────── */
const SolutionCard = ({ sol, delay = 0 }) => (
  <Box
    component={motion.div}
    initial={{ opacity: 0, y: 26, filter: "blur(4px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: .55, delay, ease: [.22,1,.36,1] }}
    whileHover={{ scale: 1.025, transition: { duration: .18 } }}
    className="sol-card"
    sx={{
      // Fill entire grid cell height for consistent bento rows
      height: "100%",
      borderRadius: { xs: "12px", md: "14px" },
      background: "rgba(255,255,255,.024)",
      border: "1px solid rgba(255,255,255,.065)",
      backdropFilter: "blur(14px)",
      p: {
        xs: "16px 16px 18px",
        sm: "18px 18px 20px",
        md: "20px 20px 22px",
        lg: "22px 22px 24px",
        xl: "24px 24px 26px",
      },
      display: "flex",
      flexDirection: "column",
      gap: { xs: "8px", md: "10px" },
      cursor: "default",
      userSelect: "none",
      // No overflow; content dictates height
      overflow: "hidden",
      transition: "border-color .22s ease, background .22s ease, box-shadow .22s ease",
      "&::before": {
        content: '""', position: "absolute",
        top: 0, left: "10%", right: "10%", height: "1px",
        background: "linear-gradient(90deg, transparent, rgba(255,255,255,.09), transparent)",
      },
      "&:hover": {
        borderColor: "rgba(30,144,255,.22)",
        background: "rgba(30,144,255,.038)",
        boxShadow: "0 4px 32px rgba(30,144,255,.07), inset 0 1px 0 rgba(30,144,255,.1)",
      },
    }}
  >
    <Box className="sol-scan"/>

    {/* top row: icon + index */}
    <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
      <Box sx={{
        // Icon scales between 17–21 px
        width: "clamp(17px, 2vw, 21px)",
        height: "clamp(17px, 2vw, 21px)",
        flexShrink: 0,
        color: "rgba(255,255,255,.3)",
        transition: "color .22s ease",
        ".sol-card:hover &": { color: "rgba(30,144,255,.72)" },
      }}>
        {ICONS[sol.icon]}
      </Box>
      <Typography sx={{
        fontFamily: "'DM Sans', sans-serif",
        fontSize: "clamp(.56rem,.75vw,.62rem)",
        fontWeight: 500,
        color: "rgba(255,255,255,.13)",
        letterSpacing: ".06em",
        transition: "color .22s ease",
        ".sol-card:hover &": { color: "rgba(255,255,255,.22)" },
      }}>
        {String(SOLUTIONS.findIndex(s => s.id === sol.id) + 1).padStart(2, "0")}
      </Typography>
    </Box>

    {/* tag */}
    <TagPill label={sol.tag}/>

    {/* name */}
    <Typography sx={{
      fontFamily: "'Bricolage Grotesque', sans-serif",
      fontWeight: 660,
      fontSize: "clamp(.82rem, 1.1vw, .95rem)",
      lineHeight: 1.28,
      letterSpacing: "-.015em",
      color: "rgba(255,255,255,.7)",
      transition: "color .22s ease",
      wordBreak: "break-word",
      overflowWrap: "break-word",
      ".sol-card:hover &": { color: "rgba(255,255,255,.9)" },
    }}>
      {sol.name}
    </Typography>

    {/* desc */}
    <Typography sx={{
      fontFamily: "'DM Sans', sans-serif",
      fontSize: "clamp(.72rem, .95vw, .8rem)",
      lineHeight: 1.72,
      color: "rgba(255,255,255,.32)",
      fontWeight: 400,
      mt: .4,
      // Allow text to breathe without overflowing the card
      wordBreak: "break-word",
      overflowWrap: "break-word",
    }}>
      {sol.desc}
    </Typography>
  </Box>
);

/* ─────────────────────── ANIMATION HELPERS ──────────────────────── */
const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: .65, delay, ease: [.22,1,.36,1] },
});

/* ─────────────────────── MAIN EXPORT ────────────────────────────── */
export default function OurSolutions() {
  const supporting = SOLUTIONS.filter(s => !s.featured);

  return (
    <>
      <Styles />

      <Box
        component="section"
        aria-label="Our Solutions"
        sx={{
          position: "relative",
          background: "#000000",
          // Vertical rhythm scales smoothly across all breakpoints
          pt: { xs: "72px", sm: "88px", md: "104px", lg: "120px", xl: "140px" },
          pb: { xs: "72px", sm: "88px", md: "112px", lg: "128px", xl: "148px" },
          overflow: "hidden",
        }}
      >
        {/* ── grid overlay ── */}
        <Box aria-hidden sx={{
          position: "absolute", inset: 0,
          backgroundImage:
            "linear-gradient(rgba(30,144,255,.05) 1px,transparent 1px)," +
            "linear-gradient(90deg,rgba(30,144,255,.05) 1px,transparent 1px)",
          backgroundSize: { xs: "40px 40px", sm: "48px 48px", md: "56px 56px", xl: "64px 64px" },
          maskImage: "radial-gradient(ellipse 80% 80% at 50% 40%,black,transparent)",
          pointerEvents: "none",
        }}/>

        {/* ── top-center ambient orb ── */}
        <Box aria-hidden component={motion.div}
          animate={{ scale:[1,1.15,1], opacity:[.45,.75,.45] }}
          transition={{ duration:9, repeat:Infinity, ease:"easeInOut" }}
          sx={{
            position: "absolute", top:"-10%", left:"50%", transform:"translateX(-50%)",
            width: { xs:300, sm:440, md:600, lg:700, xl:800 },
            height: { xs:200, sm:320, md:440, lg:500, xl:560 },
            borderRadius:"50%",
            background:"radial-gradient(ellipse, rgba(30,144,255,.07) 0%,transparent 70%)",
            filter:"blur(55px)", pointerEvents:"none",
          }}
        />

        {/* ── right corner secondary orb ── */}
        <Box aria-hidden sx={{
          position:"absolute", top:"15%", right:"-8%",
          width: { xs:160, sm:220, md:320, lg:380, xl:440 },
          height: { xs:160, sm:220, md:320, lg:380, xl:440 },
          borderRadius:"50%",
          background:"radial-gradient(circle, rgba(30,144,255,.05) 0%,transparent 70%)",
          filter:"blur(60px)", pointerEvents:"none",
        }}/>

        {/* ── bottom-left orb ── */}
        <Box aria-hidden sx={{
          position:"absolute", bottom:"5%", left:"-6%",
          width: { xs:140, sm:200, md:300, lg:360, xl:420 },
          height: { xs:140, sm:200, md:300, lg:360, xl:420 },
          borderRadius:"50%",
          background:"radial-gradient(circle, rgba(30,144,255,.04) 0%,transparent 70%)",
          filter:"blur(70px)", pointerEvents:"none",
        }}/>

        {/* ── top separator ── */}
        <Box aria-hidden sx={{
          position:"absolute", top:0, left:"50%", transform:"translateX(-50%)",
          width:{ xs:"80%", md:"60%" }, height:"1px",
          background:"linear-gradient(to right,transparent,rgba(255,255,255,.05),transparent)",
          pointerEvents:"none",
        }}/>

        {/* ── CONTAINER ── */}
        <Container
          maxWidth="xl"
          sx={{
            position: "relative",
            zIndex: 2,
            px: { xs: "16px", sm: "24px", md: "40px", lg: "56px", xl: "72px" },
            // Hard cap so content never stretches absurdly on 4K
            maxWidth: { xl: "1480px" },
          }}
        >

          {/* ═══ HEADER ═══ */}
          <Box sx={{
            textAlign: "center",
            mb: { xs: "48px", sm: "60px", md: "72px", lg: "80px", xl: "88px" },
            // Constrain header text width for readability on wide screens
            maxWidth: { xs: "100%", md: "640px", lg: "720px" },
            mx: "auto",
          }}>

            <motion.div {...fadeUp(0)}>
              <Box sx={{ display:"inline-flex", alignItems:"center", gap:1.2, mb: { xs: "20px", md: "24px" } }}>
                <Box sx={{ width: { xs: 14, md: 18 }, height:"1px", background:"rgba(30,144,255,.5)" }}/>
                <Typography sx={{
                  fontFamily:"'DM Sans',sans-serif",
                  fontSize: "clamp(.62rem,.9vw,.72rem)",
                  fontWeight:600,
                  color:"rgba(88,178,255,.9)",
                  letterSpacing:".14em",
                  textTransform:"uppercase",
                  whiteSpace: "nowrap",
                }}>
                  What We Build
                </Typography>
                <Box sx={{ width: { xs: 14, md: 18 }, height:"1px", background:"rgba(30,144,255,.5)" }}/>
              </Box>
            </motion.div>

            <motion.div {...fadeUp(.08)}>
              <Typography component="h2" sx={{
                fontFamily:"'Bricolage Grotesque',sans-serif",
                fontWeight: 760,
                fontSize: "clamp(1.7rem, 4vw, 3.1rem)",
                lineHeight: 1.1,
                letterSpacing: "clamp(-1px, -0.05em, -1.8px)",
                color: "rgba(255,255,255,.93)",
                mb: { xs: "14px", md: "18px" },
                wordBreak: "break-word",
              }}>
                Our&nbsp;
                <Box component="span" sx={{
                  background:"#1E90FF",
                  WebkitBackgroundClip:"text",
                  WebkitTextFillColor:"transparent",
                  backgroundClip:"text",
                }}>
                  Solutions
                </Box>
              </Typography>
            </motion.div>

            <motion.div {...fadeUp(.15)}>
              <Typography sx={{
                fontFamily:"'DM Sans',sans-serif",
                fontSize: "clamp(.86rem, 1.2vw, 1rem)",
                lineHeight: 1.82,
                color: "rgba(255,255,255,.38)",
                maxWidth: { xs: "100%", sm: "480px", md: "520px" },
                mx: "auto",
              }}>
                Enterprise AI systems designed for automation, intelligence,
                customer engagement, and real-world operational efficiency.
              </Typography>
            </motion.div>
          </Box>

          {/* ═══ BENTO GRID ═══ */}
          <Box sx={{
            display: "grid",
            // Responsive gap: tighter on mobile, generous on wide
            gap: { xs: "12px", sm: "14px", md: "15px", lg: "16px", xl: "18px" },
            gridTemplateColumns: {
              xs: "1fr",
              // 2-col from sm; 3-col from md; 4-col from lg
              sm: "1fr 1fr",
              md: "1fr 1fr 1fr",
              lg: "1fr 1fr 1fr 1fr",
            },
            gridTemplateAreas: {
              xs: `
                "featured"
                "health"
                "voice"
                "mess"
                "bus"
                "fee"
                "feedback"
              `,
              sm: `
                "featured featured"
                "health   voice"
                "mess     bus"
                "fee      feedback"
              `,
              // At md (3-col): featured spans 2 cols, health/voice share the 3rd
              md: `
                "featured featured health"
                "featured featured voice"
                "mess     bus       fee"
                "feedback feedback feedback"
              `,
              lg: `
                "featured featured featured health"
                "featured featured featured voice"
                "mess     bus       fee       feedback"
              `,
            },
            // Ensure rows don't collapse; featured row auto-sizes to content
            gridAutoRows: "auto",
            // Align all cells to stretch so supporting cards fill row height
            alignItems: "stretch",
          }}>

            {/* ── featured ── */}
            <Box sx={{ gridArea: "featured" }}>
              <FeaturedCard sol={SOLUTIONS[0]}/>
            </Box>

            {/* ── supporting ── */}
            {supporting.map((sol, i) => (
              <Box key={sol.id} sx={{ gridArea: sol.gridArea, display: "flex", flexDirection: "column" }}>
                <SolutionCard sol={sol} delay={.06 + i * .07}/>
              </Box>
            ))}
          </Box>

          {/* ═══ FOOTER LINE ═══ */}
          <motion.div {...fadeUp(.3)}>
            <Box sx={{
              mt: { xs: "44px", sm: "56px", md: "64px", lg: "72px" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: { xs: "14px", md: "20px" },
            }}>
              <Box sx={{ flex:1, height:"1px", background:"linear-gradient(to right,transparent,rgba(255,255,255,.06))" }}/>
              <Typography sx={{
                fontFamily:"'DM Sans',sans-serif",
                fontSize: "clamp(.64rem,.85vw,.74rem)",
                fontWeight:500,
                color:"rgba(255,255,255,.2)",
                letterSpacing:".07em",
                whiteSpace:"nowrap",
              }}>
                {SOLUTIONS.length}&nbsp;solutions across every sector
              </Typography>
              <Box sx={{ flex:1, height:"1px", background:"linear-gradient(to left,transparent,rgba(255,255,255,.06))" }}/>
            </Box>
          </motion.div>

        </Container>

        {/* ── bottom separator ── */}
        <Box aria-hidden sx={{
          position:"absolute", bottom:0, left:"50%", transform:"translateX(-50%)",
          width:{ xs:"80%", md:"60%" }, height:"1px",
          background:"linear-gradient(to right,transparent,rgba(255,255,255,.04),transparent)",
          pointerEvents:"none",
        }}/>
      </Box>
    </>
  );
}
